const values = [
  ['Respekt na prvním místě', 'Každý hlas má váhu. Vážíme si lidí, co se zapojují. Respekt a férovost na prvním místě.'],
  ['Hry, co baví', 'Od party her přes early access až po zaryté klasiky.'],
  ['Otevřená komunikace', 'Diskuze, feedback i kreativní výzvy. Allcom táhneme společně.'],
]

function AboutSection() {
  return (
    <section id="about" className="ac-section ac-width">
      <div className="ac-section-lead">
        <h2>Parta, která se zná<br />i mimo obrazovku.</h2>
        <div>
          <p>Hrajeme a povídáme si. Jsme na Discordu. Moderátor, designer, event master — u nás role vznikají podle lidí, kteří se chtějí zapojit.</p>
          <p>Pokud chceš něco rozjet, najdeš tu podporu. Prostor sdílet to, co tě baví, a tvořit společné projekty.</p>
        </div>
      </div>
      <div className="ac-about-body">
        <dl className="ac-values">
          {values.map(([title, text]) => <div key={title}><dt>{title}</dt><dd>{text}</dd></div>)}
        </dl>
        <aside className="ac-history" aria-label="Z historie Allcomu">
          <h3>Začalo to jednou lobby.</h3>
          <ol>
            <li><span>2021</span><div><strong>První lobby</strong><p>Parta kamarádů zakládá Allcom.</p></div></li>
            <li><span>2022</span><div><strong>Párkobraní</strong><p>Potkali jsme se i naživo. Vznikl vlastní moderátorský tým.</p></div></li>
            <li><span>2024+</span><div><strong>Allcom 2.0</strong><p>Komunita se rozšiřuje o IRL akce, originální projekty a členské výhody.</p></div></li>
          </ol>
          <a href="https://evobug.com/timeline" className="ac-text-link">Celý příběh v archivu Evobugu</a>
        </aside>
      </div>
    </section>
  )
}

export default AboutSection
